import request, {RequestError, noop, throwErr, parseQueryString} from './utils/request'
import Variable from './utils/variable'

const GlobalVariable = new Variable().GlobalVariable

export interface ISessionData {
    token: string
}

interface IFetchPromise {
    onSuccess?(sessionData: ISessionData): any

    onFailed?(error: SessionError): any
}

class SessionError extends Error {
    public readonly data: RequestError | { code: number, data: any }

    constructor(data: SessionError['data']) {
        super(data instanceof RequestError
            ? `[Session] Error with status ${data.status}`
            : `[Session] Error with code ${data.code}`)
        this.data = data
    }
}

export type FetchOnSuccess = (sessionData: ISessionData) => any
export type FetchOnFailed = (error: SessionError) => any

export default class Session {

    private fetchPromises: IFetchPromise[] = []
    private inFetch: boolean = false
    private sessionData: null | ISessionData = null

    public getToken(onSuccess: FetchOnSuccess = noop, onFailed: FetchOnFailed = throwErr) {
        if (this.sessionData) {
            onSuccess({...this.sessionData})
        } else {
            this.fetchToken((newSessionData) => {
                this.sessionData = newSessionData
                onSuccess({...this.sessionData})
                this.storeToken()
            }, (error) => {
                if (onFailed === noop) {
                    throw error
                } else {
                    onFailed(error)
                }
            })
        }
    }

    public login() {
        this.clear()
        const curUrl = encodeURIComponent(encodeURIComponent(window.location.href))
        const redirectUri = `${GlobalVariable.API_LOGIN_URL}${GlobalVariable.LOGIN_URL}?business_url=${curUrl}`
        const appId = `appid=${GlobalVariable.MIAN_APP_ID}`
        const responseType = `&response_type=code&scope=snsapi_base`
        const state = `&state=${GlobalVariable.WX_APP_ID}`
        const componentAppId = `&component_appid=${GlobalVariable.COMPONENT_APP_ID}#wechat_redirect`
        const search = appId + `&redirect_uri=${redirectUri}` + responseType + state + componentAppId
        const url = GlobalVariable.AUTHORIZATION_URL + '?' + search
        location.assign(url)
    }

    public logout() {
        this.clear()
        location.assign(location.href)
    }

    public clear() {
        this.clearTokenStore()
        this.sessionData = null
    }

    private promisesAllSuccess(sessionData: ISessionData) {
        this.fetchPromises.forEach(({onSuccess}) => onSuccess ? onSuccess(sessionData) : void(0))
        this.fetchPromises = []
        this.inFetch = false
    }

    private promisesAllFailed(error: SessionError) {
        this.fetchPromises.forEach(({onFailed}) => onFailed ? onFailed(error) : void(0))
        this.fetchPromises = []
        this.inFetch = false
    }

    private storeToken() {
        if (this.sessionData) {
            const {token} = this.sessionData
            localStorage.setItem('Jingxin/token', token)
        }
    }

    private loadToken(): ISessionData | null {
        const token = localStorage.getItem('Jingxin/token')

        if (token && GlobalVariable.WPK_ACC_ID === -1) {
            return {token}
        } else {
            this.clearTokenStore()
            return null
        }
    }

    private clearTokenStore() {
        Object.getOwnPropertyNames(localStorage).forEach((key) => /^Jingxin\//.test(key)
            ? localStorage.removeItem(key)
            : void(0))
    }

    private fetchToken(onSuccess: FetchOnSuccess = noop, onFailed: FetchOnFailed = throwErr) {
        // const token = this.loadToken()
        this.fetchPromises.push({onSuccess, onFailed})
        // if (token) {
        //     this.promisesAllSuccess(token)
        //     return
        // }
        const baseUrl = GlobalVariable.API_LOGIN_URL
        // alert('API_LOGIN_URL: ' + GlobalVariable.API_LOGIN_URL)
        const url = GlobalVariable.GET_TOKEN_URL
        if (!this.inFetch) {
            this.inFetch = true
            const query: { oc_code?: string, token?: string } = {}
            const oc_code = parseQueryString(window.location.search).oc_code
            if (oc_code) {
                query.oc_code = oc_code
            }
            const oldToken = localStorage.getItem('Jingxin/token')
            if (oldToken) {
                query.token = oldToken
            }
            request({ baseUrl, url, method: 'GET',  withCredentials: true, query }, (result) => {
                const {code, data} = result
                if (code === 0) {
                    const sessionData = {
                        token: data.access_token,
                        account: data.account
                    }
                    this.promisesAllSuccess(sessionData)
                } else if (code === 403) {
                    this.login()
                } else {
                    this.promisesAllFailed(new SessionError(result))
                }
            }, (error) => this.promisesAllFailed(new SessionError(error)))
        }
    }

}
